<template>
  <router-view />
</template>

<script>

export default {
};
</script>

<style>
  html{
    width: 100%;
    height: 100%;
  }
   body{
    margin: 0;
    padding: 0;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>
